import { Button, Divider, Grid, Space } from 'antd';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { SideNavigationButton } from './SideNavigationButton';
import { StyledSideNavigationBackButtonContent } from '../Styled/AppLayoutStyles';
import { routeDefinition, routes } from '../../routes';

const { useBreakpoint } = Grid;

const SideNavigation = () => {
  const screens = useBreakpoint();
  const collapsed = !screens.lg;

  return (
    <>
      <Space size='middle' align='center' direction='vertical' style={{ width: '100%', marginTop: '180px' }}>
        {routes.map((route: routeDefinition) => (
          <SideNavigationButton route={route} key={route.path} />
        ))}
        <Divider style={{ width: collapsed ? '50px' : '300px' }} />
        <Link to='https://eastcoastwarehouse.com' target='_blank'>
          <Button type='text' icon={<FontAwesomeIcon icon={solid('home')} size={'lg'} />}>
            {!collapsed && (
              <StyledSideNavigationBackButtonContent>
                <span className='prefix'>Back to</span>
                <span className='link'>eastcoastwarehouse.com</span>
              </StyledSideNavigationBackButtonContent>
            )}
          </Button>
        </Link>
      </Space>
    </>
  );
};

export default SideNavigation;
